import axios from 'axios';

export const getReadableFileSize = sizeInBytes => {
  const KB = 1024;
  const MB = KB * 1024;

  let displaySize = sizeInBytes;
  let unit = 'B';

  if (sizeInBytes >= MB) {
    displaySize = sizeInBytes / MB;
    unit = 'MB';
  } else if (sizeInBytes >= KB) {
    displaySize = sizeInBytes / KB;
    unit = 'KB';
  }

  const formattedSize = displaySize.toLocaleString(undefined, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  return `${formattedSize} ${unit}`;
};

export const getFileSize = async url => {
  try {
    if (!url || typeof url !== 'string') {
      return null;
    }

    const response = await axios.head(url);
    const contentLength = response.headers['content-length'] || response.headers['Content-Length'];

    if (contentLength) {
      const sizeInBytes = parseInt(contentLength, 10);
      return getReadableFileSize(sizeInBytes);
    }

    return null;
  } catch (error) {
    console.log('파일 크기 가져오기 실패:', error);
    return null;
  }
};

// 이미지와 기타 파일 분류
export const classifyFiles = files => {
  const images = [];
  const others = [];

  // FileList나 배열 모두 처리할 수 있도록 Array.from 사용
  const fileArray = Array.from(files || []);

  fileArray.forEach(file => {
    if (file.type.startsWith('image/')) {
      images.push(file);
    } else {
      others.push(file);
    }
  });

  return { images, others };
};
